import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  // 状态管理
  state: {
    vehiclesLocations: 0
  },
  // 修改 state
  mutations: {
    setSvehiclesLocations(state, params) {
      state.vehiclesLocations = params
    }
  },
  // 异步操作
  actions: {
    setvehiclesLocationsAct(context, params) {
      let {
        commit
      } = context
      commit('setSvehiclesLocations', params)
    }
  },
  modules: {}
})